import {useGetMe} from './useGetMe';

/**
 * The client's BU id, sourced from the DB via GET api/customers/bu (role_user) —
 * the authoritative source, independent of the auth provider. The IdBu token
 * claim is no longer used, so the IdP token doesn't need to carry it.
 */
export const useClientId = (): string => {
  const customer = useGetMe();

  return customer?.id != null ? String(customer.id) : '';
};
